import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { openLoginModal } = useAuth();

  useEffect(() => {
    // Open the login modal when this page is accessed directly
    openLoginModal();
    
    // Redirect to home page or the page they were trying to access
    const from = location.state?.from?.pathname || '/';
    navigate(from, { replace: true });
  }, [navigate, location, openLoginModal]);

  // This component doesn't render anything as it just triggers the modal
  return null;
}